import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const AvatarImage = styled.img`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: block;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background-color: ${COLORS.gray40};
  object-fit: cover;
`;

export default AvatarImage;
